import React, { useCallback, useEffect, useRef } from 'react';
import { TranslationKeys } from '../../../../locale/localizationContext';
import { useLanguage } from '../../../../locale/useLanguage';
import { TimePickerPreset } from '../../../../models';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperRef } from 'swiper/types';

import 'swiper/css';

import './PresetsSlider.css';

type PresetsSliderProps = {
  presets: TimePickerPreset[];
  selectedIndex: number;
  onPresetChange?: (index: number) => void;
};

export const PresetsSlider: React.FC<PresetsSliderProps> = ({
  presets,
  selectedIndex,
  onPresetChange,
}) => {
  const [t] = useLanguage();

  const isChangedProgrammatically = useRef<boolean>(false);
  const swiperRef = useRef<SwiperRef | null>(null);

  useEffect(() => {
    if (selectedIndex !== swiperRef.current?.activeIndex) {
      isChangedProgrammatically.current = true;
      swiperRef.current?.slideTo(selectedIndex);
    }
  }, [selectedIndex]);

  const onSlideChange = useCallback(
    (swiper: SwiperRef) => {
      if (isChangedProgrammatically.current) {
        isChangedProgrammatically.current = false;
      } else {
        onPresetChange?.(swiper.activeIndex);
      }
    },
    [onPresetChange]
  );

  const updateSwiperRef = useCallback((swiper: SwiperRef) => {
    swiperRef.current = swiper;
  }, []);

  return (
    <Swiper
      slidesPerView={'auto'}
      centeredSlides={true}
      grabCursor
      onSlideChange={onSlideChange}
      slideToClickedSlide
      onSwiper={updateSwiperRef}
    >
      {presets.map((p) => {
        return (
          <SwiperSlide key={p.id}>
            {({ isActive }) => (
              <div
                className={`default-slots-slider--carousel-container ${
                  isActive ? 'default-slots-slider-slide-active' : ''
                }`}
              >
                <div className="default-slots-slider--carousel-card">
                  <h3 className="no-highlight default-slots-slider--card-title">
                    {t(
                      p.titleTranslationKey as TranslationKeys<string>
                    ).toUpperCase()}
                  </h3>
                  <p className="no-highlight default-slots-slider--card-paragraph">
                    {t(p.descriptionTranslationKey as TranslationKeys<string>)}
                  </p>
                </div>
              </div>
            )}
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};
